import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  CircularProgress,
} from '@mui/material';
import { formatCPF_CNPJ } from '../utils/formatters';

const LoginForm = ({ onSubmit, error, loading, empresa }) => {
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const { logo, nome, cores } = empresa;

  const handleUsuarioChange = (e) => {
    const rawValue = e.target.value.replace(/\D/g, '');
    setUsuario(formatCPF_CNPJ(rawValue));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(usuario.replace(/\D/g, ''), senha);
  };

  return (
    <Paper
      elevation={10}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        p: { xs: 3, sm: 4 },
        width: '100%',
        maxWidth: 460,
        mx: 'auto',
        borderRadius: 4,
        borderTop: `6px solid ${cores.primary}`,
        boxShadow: '0 24px 80px rgba(15, 23, 42, 0.15)',
        backgroundColor: 'rgba(255,255,255,0.96)',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: `linear-gradient(135deg, ${cores.secondary}14, transparent 55%)`,
          pointerEvents: 'none',
        }}
      />

      <Box sx={{ position: 'relative', zIndex: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
          <a href={logo.href} target="_blank" rel="noopener noreferrer">
            <Box
              component="img"
              src={logo.src}
              alt={logo.alt}
              sx={{ height: logo.height, maxWidth: '100%' }}
            />
          </a>
        </Box>

        <Typography variant="h5" gutterBottom align="center" sx={{ mb: 1, fontWeight: 700 }}>
          {nome}
        </Typography>

        <Typography variant="body2" align="center" color="text.secondary" sx={{ mb: 3 }}>
          Sistema de emissão e gestão de boletos
        </Typography>

      <Box component="form" onSubmit={handleSubmit} noValidate>
        <TextField
          label="CPF ou CNPJ"
          value={usuario}
          onChange={handleUsuarioChange}
          fullWidth
          margin="normal"
          required
          autoComplete="username"
          variant="outlined"
          placeholder="000.000.000-00"
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="Senha"
          type="password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          fullWidth
          margin="normal"
          required
          autoComplete="current-password"
          variant="outlined"
          InputLabelProps={{ shrink: true }}
        />

        {error && (
          <Typography color="error" variant="body2" sx={{ mt: 1, textAlign: 'center' }}>
            {error}
          </Typography>
        )}

        <Button
          type="submit"
          variant="contained"
          fullWidth
          size="large"
          disabled={loading}
          sx={{
            mt: 3,
            py: 1.3,
            fontWeight: 700,
            background: cores.primary,
            '&:hover': {
              background: cores.primaryHover,
            },
          }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Entrar'}
        </Button>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', mt: 3, gap: 1, color: 'text.secondary' }}>
        <Typography variant="caption" color="text.secondary">
          Acesso seguro para colaboradores e parceiros.
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
          <Box
            component="img"
            src="img/LogoWeb.jpg"
            alt="Compsoft"
            sx={{ height: 24 }}
          />
          <Typography variant="caption" color="text.secondary">
            <a
              href="https://www.compsoft.com.br"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              www.compsoft.com.br
            </a>
          </Typography>
        </Box>
      </Box>
    </Box>
    </Paper>
  );
};

export default LoginForm;